import { Component, Inject, OnInit } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

// UTILITIES
import { trackByValue } from 'v2/modules/shared/util/track-by.util';

@Component({
  selector: 'app-ui-multiple-confirmation-dialog',
  templateUrl: './ui-multiple-confirmation-dialog.component.html',
  styleUrls: ['./ui-multiple-confirmation-dialog.component.scss'],
})
export class UiMultipleConfirmationDialogComponent implements OnInit {
  seeMore :boolean = false;
  displayedValues :string[];
  trackByValue = trackByValue;

  constructor(
    public dialogRef :MatDialogRef<UiMultipleConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data :{ title :string; values :string[] },
  ) {}

  ngOnInit() :void {
    this.resetToInitialState();
  }

  onCancelOrShowLess() :void {
    if (this.seeMore) {
      this.resetToInitialState();
    } else {
      this.dialogRef.close(false);
    }
  }

  onConfirm() :void {
    this.dialogRef.close(true); // Confirm deletion
  }

  expandDialog() :void {
    this.seeMore = true;
    this.displayedValues = this.data.values;
    this.dialogRef.updateSize('1080px', 'auto');
  }

  private resetToInitialState() :void {
    this.seeMore = false;
    this.displayedValues = this.data.values.slice(0, 5);
    this.dialogRef.updateSize('720px', 'auto');
  }
}
